module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "player",
    on: {
      "click": _vm.details
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "total",
    class: {
      highest: _vm.isHighest
    }
  }, [_vm._v(_vm._s(_vm.total))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_c('span', {
    class: {
      invisible: _vm.isBlitzInvisible
    }
  }, [_vm._v("Blitz: " + _vm._s(_vm.lastBlitz))]), _vm._v(" "), _c('span', {
    class: {
      invisible: _vm.isDutchInvisible
    }
  }, [_vm._v("Dutch: " + _vm._s(_vm.lastDutch))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f05e93!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 90
// module chunks = 2